import { Input } from "@mantine/core";
import { useMemo } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import Select from "src/components/shared/_FormInputs/Select";
import { useCheckPerm, useIsOnline } from "src/hooks";
import { vesselTypeData } from "src/mock/selectOptions";

const VesselTypeInput = () => {
  const { control, register } = useFormContext();
  const isOnline = useIsOnline();
  const checkPerm = useCheckPerm();
  const readOnly = useMemo(
    () => !checkPerm("editparticulars") || !isOnline,
    [checkPerm, isOnline],
  );
  const type = useWatch({ control, name: "vtype" });

  return (
    <>
      <Input.Wrapper label="Vessel Type">
        <Select
          name="vtype"
          control={control}
          data={vesselTypeData}
          readOnly={readOnly}
        />
      </Input.Wrapper>
      {type === "VT8" && (
        <Input.Wrapper label="Specify Vessel Type">
          <Input {...register("vtypeother")} readOnly={readOnly} />
        </Input.Wrapper>
      )}
    </>
  );
};

export default VesselTypeInput;
